import React from 'react';

export interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  // Filter out any empty items just in case
  const filteredItems = items.filter(item => item && item.label);
  return (
    <nav className="breadcrumb-nav" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {filteredItems.map((item, idx) => (
          <React.Fragment key={idx}>
            <li className="breadcrumb-item">
              {item.onClick ? (
                <button className="breadcrumb-link" onClick={item.onClick}>{item.label}</button>
              ) : (
                <span className="breadcrumb-current">{item.label}</span>
              )}
            </li>
            {idx < filteredItems.length - 1 && (
              <li aria-hidden="true" className="breadcrumb-separator">/</li>
            )}
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
